import { formatMentionTiming } from "@/utils";
import { useMediaSelector } from "media-chrome/react/media-store";

export default function CurrentTimeDisplay() {
  const mediaCurrentTime =
    useMediaSelector((state) => state.mediaCurrentTime) ?? 0;

  return (
    <p className="text-xs text-muted-foreground tabular-nums font-semibold">
      {formatMentionTiming(mediaCurrentTime)}
    </p>
  );
}
